import { CAMPAIGN as BASE } from "../route";

export const MEDIAS = BASE.sub("/medias");
export const MEDIA = BASE.sub("/medias/:mediaId");
